import { data } from '../../svg/Sun/data';
import { makeIcon } from '../makeIcon';

export const Sun = makeIcon(data, 'sun', 'Sun');

export default Sun;
